import { useEffect, useState } from 'react';
import { centerClient } from '../../shared/clients';
import { Table } from 'rsuite';
import Column from 'rsuite/esm/Table/TableColumn';
import { Cell, HeaderCell, RowDataType } from 'rsuite-table';
import { Button } from 'react-bootstrap';
import { ITreeNode } from 'blick.react.utils';
import { getTreeTableWithProperty, ITreeTableRow, TreeTableType } from './TablesHlp';
import { FindDevice } from '../Administration/forms/FindDeviceForm';
import { JSX } from 'react/jsx-runtime';

interface ITreeTableProps {
    tabIsActive: boolean;
    treeTableType: TreeTableType;
    width: string;
}
const getAdditionalColumns = (treeTableType: TreeTableType) => {
    const columns: JSX.Element[] = [];
    switch (treeTableType) {
        case TreeTableType.ElapsingPayment:
            columns.push(
                <Column resizable flexGrow={150}>
                    <HeaderCell align="center">Баланс</HeaderCell>
                    <Cell align="center">
                        {(rowData: RowDataType<ITreeNode<ITreeTableRow>>) =>
                            rowData.data &&
                            rowData.data.device.Balance
                        }
                    </Cell>
                </Column>
            );
            columns.push(
                <Column resizable flexGrow={150}>
                    <HeaderCell align="center">Абон. пл</HeaderCell>
                    <Cell align="center">
                        {(rowData: RowDataType<ITreeNode<ITreeTableRow>>) =>
                            rowData.data &&
                            rowData.data.device.Charge
                        }
                    </Cell>
                </Column>
            );
            columns.push(
                <Column resizable flexGrow={150}>
                    <HeaderCell align="center">Дней</HeaderCell>
                    <Cell align="center">
                        {(rowData: RowDataType<ITreeNode<ITreeTableRow>>) =>
                            rowData.data &&
                            rowData.data.device.Balance / rowData.data.device.Charge
                        }
                    </Cell>
                </Column>
            );
    }
    return columns;
}
const TreeTableDevices = (props: ITreeTableProps) => {
    const { tabIsActive, treeTableType, width } = props;
    const [blockedDevices, setBlockedDevices] = useState<ITreeNode<ITreeTableRow>[]>([]);
    const [expandedKeys, setExpandedKeys] = useState(['0']);
    const [isLoading, setIsLoading] = useState(false);

    const onExpand = (expanded, item) => {
        let expandedRowKeys = expandedKeys;
        if (expanded) {
            expandedRowKeys.push(item.key);
        } else {
            expandedRowKeys = expandedKeys.filter(_ => _ !== item.key);
        }
        setExpandedKeys([...expandedRowKeys]);
    }
    const getDevices = () => {
        setIsLoading(true);
        centerClient.getAllDevices()
            .then((res) => {
                const data = res.data;
                if (!data)
                    return;
                const newExpandedKeys: string[] = [];
                const newData = getTreeTableWithProperty(data, treeTableType, newExpandedKeys);
                setBlockedDevices(newData);
                setExpandedKeys(newExpandedKeys);
            })
            .catch(() => void 0)
            .finally(() => setIsLoading(false));
    }
    useEffect(() => {
        if (!tabIsActive)
            return;

        getDevices();
    }, [tabIsActive])
    const rowClickHandler = (rowData: ITreeTableRow) => {
        FindDevice(rowData.device.Serial);
    }
    const getRowClass = (_, rowIndex: number) => {
        const isOdd = rowIndex % 2 !== 0;
        const rowClasses = isOdd ? 'odd-row' : 'even-row';

        return rowClasses;
    };


    return (
        <div style={{ height:'100%', width:width }}>
            <Table
                loading={ isLoading}
                isTree
                bordered
                cellBordered
                virtualized
                data={blockedDevices}
                rowHeight={28}
                //ref={treeTableRef}
                rowKey="key"
                fillHeight
                onExpandChange={onExpand}
                expandedRowKeys={expandedKeys}
                rowClassName={getRowClass}

            >
                <Column resizable flexGrow={250}>
                    <HeaderCell align="center">Модель</HeaderCell>
                    <Cell>
                        {(rowData) =>
                            rowData.data ?
                                rowData.data.device.DeviceModelName : rowData.label
                        }
                    </Cell>
                </Column>
                <Column resizable flexGrow={150}>
                    <HeaderCell align="center">с/н</HeaderCell>
                    <Cell align="center">
                        {(rowData: RowDataType<ITreeNode<ITreeTableRow>>) =>
                            rowData.data ?
                            rowData.data.device.Serial :""
                        }
                    </Cell>
                </Column>
                {
                    getAdditionalColumns(treeTableType)
                }
                <Column resizable
                    minWidth={100}
                    flexGrow={100}>
                    <HeaderCell align="center">{"Действие"}</HeaderCell>
                    <Cell align="center">
                        {(rowData: RowDataType<ITreeNode<ITreeTableRow>>) =>
                            rowData.data &&
                                <Button
                                    variant="custom"
                                    style={{ fontSize: '14px', padding:'10px', lineHeight: '0' }}
                                    onClick={() => {
                                        rowClickHandler(rowData.data)
                                    }}
                                >
                                    Перейти
                                </Button> 
                        }
                    </Cell>
                </Column>
            </Table>
        </div>
    )
};

export default TreeTableDevices;
